import { QRCodeCanvas } from "qrcode.react";
import React from "react";
import "./style.css";
import { useTranslation } from "react-i18next";

function Qrcode() {
  const { t } = useTranslation();

  const mobileAppLinkPS =
    "https://play.google.com/store/apps/details?id=com.CliClaim.Client";
  const mobileAppLinkAS =
    "https://apps.apple.com/tn/app/cliclaim-client/id6749679124?l=fr-FR";

  const openLink = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="container mt-3 " style={{ marginLeft: "20px" }}>
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
          <div className="container_mobile_app mb-2 d-flex flex-column align-items-center">
            <div className="qrcode2 text-center mb-3">
              <QRCodeCanvas
                value={mobileAppLinkPS}
                size={120}
                bgColor={"#000000"}
                fgColor={"#ffffff"}
                level={"H"}
                imageSettings={{
                  src: require("../../images/favicon.ico"),
                  x: undefined,
                  y: undefined,
                  height: 32,
                  width: 32,
                  excavate: true,
                }}
              />
            </div>
            <button
              onClick={() =>
                openLink(
                  "https://play.google.com/store/apps/details?id=com.CliClaim.Client"
                )
              }
              className="market-btn google-btn"
              style={{ width: "160px" }}
            >
              <span className="market-button-subtitle">
                {t("footer.downloadTitle")}
              </span>
              <span className="market-button-title">Google Play</span>
            </button>
          </div>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
          <div className="container_mobile_app mb-2 d-flex flex-column align-items-center">
            <div className="qrcode2 text-center mb-3">
              <QRCodeCanvas
                value={mobileAppLinkAS}
                size={120}
                bgColor={"#000000"}
                fgColor={"#ffffff"}
                level={"H"}
                includeMargin={false}
                imageSettings={{
                  src: require("../../images/favicon.ico"),
                  x: undefined,
                  y: undefined,
                  height: 32,
                  width: 32,
                  excavate: true,
                }}
              />
            </div>
            <button
              onClick={() =>
                openLink(
                  "https://apps.apple.com/tn/app/cliclaim-client/id6749679124?l=fr-FR"
                )
              }
              className="market-btn apple-btn"
              style={{ width: "160px" }}
            >
              <span className="market-button-subtitle">
                {t("footer.downloadTitle")}
              </span>
              <span className="market-button-title">App Store</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Qrcode;
